export const UNNAMED_PARTNER = 'unnamed partner';
